import { View } from "binder"
import { DebitTransferPaymentViewModel } from "./debitTransferPayment-viewModel"
import { DebitCardSelectorViewModel } from "src/Sell/Payment/debitPayment/debitCardSelector-viewModel";

export class DebitTransferPaymentView extends View<DebitTransferPaymentViewModel>{
    GetViewUniqueId(): string {
        return "V-5CD550F7-AA95-41C8-A08E-F757F3D39900"
    }
    loadHtml(): string {
        let element = require('./debitTransferPayment.html').default;
        let style = require('./debitTransferPayment.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set cardNo(v: string) { this._cardNo = v; } public get cardNo(): string { return this._cardNo;} private _cardNo: string;
    public set debitCardSelectorViewModel(v: DebitCardSelectorViewModel) { this._debitCardSelectorViewModel = v; } public get debitCardSelectorViewModel(): DebitCardSelectorViewModel { return this._debitCardSelectorViewModel;} private _debitCardSelectorViewModel: DebitCardSelectorViewModel;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode;} private _traceCode: string;
    public set invoiceId(v: string) { this._invoiceId = v; } public get invoiceId(): string { return this._invoiceId;} private _invoiceId: string;
    public set isFromRootDistrict(v: boolean) { 
        this._isFromRootDistrict = v; 
        this.debitCardSelectorViewModel.refresh();
    } public get isFromRootDistrict(): boolean { return this._isFromRootDistrict;} private _isFromRootDistrict: boolean;
    
    public createPayment(){
        this.dataContext.createPayment();
    }
    back(){
        this.dataContext.back();
    }
}
